import { useContext, useEffect } from 'react'
import { NavContext } from '../../context/global_context'
import ErrorCard from '../../components/common/ErrorCard'
import { useIntl } from 'react-intl'
import { CloseCircleOutlined } from '@ant-design/icons'

const NotPermitted = () => {
  const intl = useIntl()
  const [state, dispatch] = useContext(NavContext)
  useEffect(() => {
    dispatch({
      type: 'header',
      data: { show_back_btn: false, show_home_button: true },
    })
  }, [])
  return (
    <div className="page not-permitted">
      <ErrorCard
        icon={CloseCircleOutlined} 
        iconStyle={{ color: 'var(--color-form-error-broder, #FF4D4F)' }}
        title={intl.formatMessage({ id: 'auth.accessDenied' })}
        sub_title={intl.formatMessage({ id: 'auth.notPermitted' })}
      />
    </div>
  )
}

export default NotPermitted
